type Params = {
  /** style的元素,往它上面进行赋值 */
  style: CSSStyleDeclaration
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cssMap: Record<string, any>
  /** 是否递归赋值 */
  isRecursive?: boolean
}
/** 递归的往dom上赋值css变量 */
export const styleAppendCssVar = ({
  style,
  cssMap = {},
  isRecursive = false
}: Params) => {
  for (const key in cssMap) {
    // 类型为string,则直接进行赋值
    if (typeof cssMap[key] === 'string') {
      // forin的类型推断,它不允许有?:的场景,有的话,就必须强转一下,告诉它我们是有东西的
      style.setProperty(key, cssMap[key] as string)
    }
    // 如果是嵌套的对象,则进行递归
    else if (
      Object.prototype.toString.call(cssMap[key]) === '[object Object]'
    ) {
      if (isRecursive) {
        styleAppendCssVar({
          style,
          cssMap: cssMap[key],
          isRecursive
        })
      }
    }
  }
}
